const Dutch = {
    VIDEO_ACQUIRING_LICENSE: 'Ophalen licentie..',
    VIDEO_BUFFERING: 'Bufferen...',
    VIDEO_ACQUIRING_MANIFEST: 'Ophalen manifest..',
    INITIALIZING: 'Initialiseren',
    NONE: 'Geen',
};

export default Dutch;



// WEBPACK FOOTER //
// ./src/js/localization/default-nl.js